module.exports = __webpack_public_path__ + "img/person-dash-fill.be0bb9be.svg";